import React, { useState } from 'react';
import { Mail, MapPin, Send } from 'lucide-react';
import { toast } from '../hooks/use-toast';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission for now
    toast({
      title: '¡Mensaje enviado!',
      description: 'Nos pondremos en contacto contigo pronto.',
    });
    setFormData({
      name: '',
      email: '',
      company: '',
      message: ''
    });
  };

  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-white to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Descubre cómo podemos ayudarte
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Contáctanos y comencemos a transformar tu negocio juntos
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div>
            <div className="bg-gradient-to-br from-white to-white rounded-2xl p-8 border border-gray-200 mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Información de contacto</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-orange-50 rounded-lg flex items-center justify-center">
                    <Mail className="w-6 h-6 text-[#ff6b35]" />
                  </div>
                  <div>
                    <h4 className="text-gray-900 font-semibold mb-1">Email</h4>
                    <p className="text-gray-600">contacto@cloudexpert.cl</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-orange-50 rounded-lg flex items-center justify-center">
                    <MapPin className="w-6 h-6 text-[#ff6b35]" />
                  </div>
                  <div>
                    <h4 className="text-gray-900 font-semibold mb-1">Dirección</h4>
                    <p className="text-gray-600">Santiago, Chile</p>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA Box */}
            <div className="bg-gradient-to-r from-orange-50 to-gray-50 rounded-2xl p-8 border border-[#ff6b35]/30">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                ¿Listo para transformar tu negocio?
              </h3>
              <p className="text-gray-700 mb-6">
                Agenda una consultoría gratuita con nuestros expertos y descubre cómo podemos ayudarte a alcanzar tus objetivos.
              </p>
              <div className="inline-flex items-center gap-2 text-[#ff6b35] font-semibold">
                <span>Respuesta en menos de 24 horas</span>
                <span>✔️</span>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-gradient-to-br from-white to-white rounded-2xl p-8 border border-gray-200">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-gray-900 font-medium mb-2">
                  Nombre y apellidos *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:border-[#ff6b35] transition-colors"
                  placeholder="Tu nombre completo"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-gray-900 font-medium mb-2">
                  Email de empresa *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:border-[#ff6b35] transition-colors"
                  placeholder="tu@empresa.com"
                />
              </div>

              <div>
                <label htmlFor="company" className="block text-gray-900 font-medium mb-2">
                  Compañía *
                </label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:border-[#ff6b35] transition-colors"
                  placeholder="Nombre de tu empresa"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-gray-900 font-medium mb-2">
                  Háblanos de tus objetivos *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={4}
                  className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:border-[#ff6b35] transition-colors resize-none"
                  placeholder="Cuéntanos qué desafíos quieres resolver..."
                />
              </div>

              <button
                type="submit"
                className="w-full bg-[#ff6b35] hover:bg-[#f97316] text-gray-900 px-6 py-4 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-[#ff6b35]/30 flex items-center justify-center gap-2 group"
              >
                Enviar mensaje
                <Send className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>

              <p className="text-sm text-gray-500 text-center">
                * Campos obligatorios
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;